import gql from 'graphql-tag';

export default gql`
mutation competencyDocumentItemDelete(
    $documentId: UUID!,
    $id: UUID!
  ) {
    competencyDocumentItemDelete (input: {
      documentId: $documentId,
      id: $id
    }) {
        documentItem {
            id
            documentId
            abbreviatedStatement
            fullStatement
            humanCodingScheme
            createdAt
            modifiedAt
        }
    }
  }
`;